import icon from 'vue-svgicon';

icon.register({
    'bold/sign-badge-circle': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="12" r="12"/>`,
    },
});
